"use client";

import type { VideoDetailLayoutProps } from "./types";
import { VideoDetailDescription } from "./video-detail-description";
import { VideoDetailMeta } from "./video-detail-meta";
import { VideoDetailPlayer } from "./video-detail-player";
import { VideoDetailPlaylist } from "./video-detail-playlist";
import { VideoDetailRecommendations } from "./video-detail-recommendations";

export function VideoDetailLayout({
    isLoggedIn,
    onLoginRequest,
    videoTitle,
    descriptionHtml,
    currentVideo,
    seekTime,
    autoPlay,
    onEnd,
    videoTrainer,
    seriesId,
    bookmarkCount,
    isBookmarked,
    onBookmark,
    seriesTitle,
    videos,
    currentVideoId,
    isPremium,
    onSelect,
    recommendations,
    modals,
}: VideoDetailLayoutProps) {
    return (
        <div className="flex w-full flex-col gap-8 py-10">
            <div className="flex flex-col gap-6 lg:flex-row">
                <div className="flex min-w-0 flex-2 flex-col gap-6">
                    <VideoDetailPlayer
                        currentVideo={currentVideo}
                        seekTime={seekTime}
                        autoPlay={autoPlay}
                        onLoginRequest={onLoginRequest}
                        onEnd={onEnd}
                    />
                    <VideoDetailMeta
                        title={videoTitle}
                        videoTrainer={videoTrainer}
                        seriesId={seriesId}
                        bookmarkCount={bookmarkCount}
                        isBookmarked={isBookmarked}
                        isLoggedIn={isLoggedIn}
                        onLoginRequest={onLoginRequest}
                        onBookmark={onBookmark}
                    />
                    <VideoDetailDescription
                        title={videoTitle}
                        descriptionHtml={descriptionHtml}
                    />
                </div>

                <VideoDetailPlaylist
                    seriesTitle={seriesTitle}
                    videos={videos}
                    currentVideoId={currentVideoId}
                    isPremium={isPremium}
                    isLoggedIn={isLoggedIn}
                    onSelect={onSelect}
                />
            </div>

            {recommendations && (
                <VideoDetailRecommendations {...recommendations} />
            )}

            {modals}
        </div>
    );
}
